'use es6';

export const DOMAIN_INVALID = 'DOMAIN_INVALID';
export const TARGET_PAGE_ERROR = 'TARGET_PAGE_ERROR';
export const WEBSITE_GRADER_ERROR = 'WEBSITE_GRADER_ERROR';